import { render, staticRenderFns } from "./ChatMensagem.vue?vue&type=template&id=f966ae30&scoped=true"
import script from "./ChatMensagem.vue?vue&type=script&lang=js"
export * from "./ChatMensagem.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagem.vue?vue&type=style&index=0&id=f966ae30&prod&lang=css"
import style1 from "./ChatMensagem.vue?vue&type=style&index=1&id=f966ae30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f966ae30",
  null
  
)

export default component.exports